import React,{useContext,useEffect, useState, useRef, useCallback} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { deleteRequest, getRequest, postRequest } from '../../api/ApiController';
import { confirmDialog } from 'primereact/confirmdialog';
import { SaveIcon, AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, StepForwardIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { Checkbox } from "primereact/checkbox";
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';

export default function UserAdd({user,type}){
    const sanitizeUserForCopy = (source) => ({
        id: '',
        username: '',
        role: source?.role || '',
        employee_id: '',
    });

    const [state,dispatch] = useContext(DatabaseContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText}= useContext(UtilContext);
    const { t } = useContext(LocaleContext);

    const [formUser,setFormUser] = useState(type === 'copy' ? sanitizeUserForCopy(user) : user);
    const [userType, setUserType] = useState(type === 'copy' ? 'add' : type);
    const [accountEmail,setAccountEmail] = useState((type === 'copy' ? null : user?.employee?.email));

    const [scrollIcons,setScrollIcons] = useState(true);

    const [visiblePassword,setVisiblePassword] = useState(false);
    const [newPassword,setNewPassword] = useState("");

    const [closeTab,setCloseTab] = useState(false);

    const [priorityDepartments, setPriorityDepartments] = useState((user?.priority_departments!=null)?user.priority_departments.map((dep) => dep.id):[]);

    const submitRef = useRef(null);

    const onDepartmentsChange = (e) => {
        let _departments = [...priorityDepartments];

        if (e.checked)
            _departments.push(e.value);
        else
            _departments.splice(_departments.indexOf(e.value), 1);
            setPriorityDepartments(_departments);
    }

    function randomString(len, charSet) {
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    }

    useEffect(() => {
        // Update the document title using the browser API
        if(userType=="edit"){
            setScrollIcons(false);
        }
    },[userType]);

    const userFormikValidate = useCallback((values) => {
        const errors = {};
        if (values.username.length<5) {
            errors.username = t('UserAdd.Error.UsernameShort');
        }
        if (!values.username) {
            errors.username = t('Common.RequiredField');
        }
        if (values.role=="") {
            errors.role = t('Common.RequiredField');
        }
        let usernames = state.users.map(user => user.username);
        if(userType==="add" && usernames.includes(values.username)){
            errors.username = t('UserAdd.Error.UsernameTaken');
        }
        if(userType==="edit" && state.users.filter(user => user.id != formUser.id).map(user => user.username).includes(values.username)){
            errors.username = t('UserAdd.Error.UsernameTaken');
        }
        if(values.employee_id!="" && values.employee_id!=null){
            let email = state.employees.filter(employee => employee.id == values.employee_id)[0]?.email;
            if(email=="" || email==null){
                errors.employee_id = t('UserAdd.Error.EmployeeNoEmail');
            } 
        }
        return errors;
    }, [t, userType, formUser, state.users, state.employees]);

    const userformik = useFormik({
        initialValues: formUser == null?{
            id:'',username:'',role:'',employee_id:''
        }:formUser,
        enableReinitialize:true,
        validate: userFormikValidate,
        onSubmit: values => {
            if((values.employee_id==null || values.employee_id=="") && priorityDepartments.length==0){
                alert(t('UserAdd.Alert.AssignDepartments'));
            }
            else{
                if(values.employee_id==null || values.employee_id==""){
                    values.password = randomString(8);
                    setNewPassword(values.password);
                }
                let formData2 = new FormData();
                delete values?.priority_departments;
                if(priorityDepartments.length>0){
                    values.employee_id = "";
                    for (var i = 0; i < priorityDepartments.length; i++) {
                        formData2.append("priority_departments[]", priorityDepartments[i]);
                    }
                }
                for (let value in values) {
                    formData2.append(value, values[value] != null ? values[value] : "");
                }
                setDialogText(t('Common.Saving'));
                setVisible(true);
                if(userType==="add"){
                    postRequest('/api/users', formData2,true)
                    .then((response) => {
                        setFormUser(response.data);
                        userformik.setValues(response.data);
                        getRequest("/api/users").then((response) => {
                            dispatch({type:'load_users',newUsers:response.data});
                            setUserType("edit");
                            setVisible(false);
                            toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('UserAdd.Toast.UserSaved')});
                            if(values.password!="")setVisiblePassword(true);
                            else if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        });
                        getRequest("/api/employees").then((response) => {
                            dispatch({type:'load_employees',newEmployees:response.data});
                        });
                    }).catch((reason) => {
                        setVisible(false);
                        alert(t('Common.Toast.ActionFailedDetail'));
                    })
                }
                else{
                    postRequest(`/api/users/update/${userformik.values.id}`, formData2,true)
                    .then((response) => {
                        setFormUser(response.data);
                        userformik.setValues(response.data);
                        getRequest("/api/users").then((response) => {
                            dispatch({type:'load_users',newUsers:response.data});                        
                            if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                            setVisible(false);
                            toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('UserAdd.Toast.UserUpdated') });
                        });
                        getRequest("/api/employees").then((response) => {
                            dispatch({type:'load_employees',newEmployees:response.data});
                        });
                    }).catch((reason) => {
                        setVisible(false);
                        alert(t('Common.Toast.ActionFailedDetail'));
                    })
                }
            }
        },
    });

    function addNewUser(){
        dispatch({type:'create_new_tab',name: t('UserList.Tab.New'), translationKey: 'UserList.Tab.New', legacyLabel: t('UserList.Tab.New'),page:'UserAdd',props:{user: null,type:'add'},mask:'gset006'})
    }

    function copyUser(){
        dispatch({type:'create_new_tab',name: t('UserList.Tab.New'), translationKey: 'UserList.Tab.New', legacyLabel: t('UserList.Tab.New'),page:'UserAdd',props:{user: sanitizeUserForCopy(userformik.values),type:'copy'},mask:'gset006'})
    }

    const setUserWithDepartments = (user) => {
        setFormUser(user);
        if (user?.priority_departments) setPriorityDepartments(user.priority_departments.map((dep) => dep.id));
    };
    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = createArrayNavigateHandlers(state.users, userformik.values?.id, setUserWithDepartments);

    const acceptReset = () => {
        let formData2 = new FormData();
        let resetString = randomString(8);
        console.log(userformik.values.employee_id);
        if(userformik.values.employee_id=="" || userformik.values.employee_id==null){
            setNewPassword(resetString);
            formData2.append("reset_password", resetString);
        }
        postRequest(`/api/users/reset_password/${formUser.id}`, formData2,true)
        .then((response) => {
            if(userformik.values.employee_id=="" || userformik.values.employee_id==null)setVisiblePassword(true);
            toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('UserAdd.Toast.PasswordReset') });
        }).catch((reason) => {
            alert(t('Common.Toast.ActionFailedDetail'));
            toast?.current?.show({ severity: 'warn', summary: t('UserAdd.Toast.ResetRejectedSummary'), detail: t('UserAdd.Toast.ResetRejectedDetail'), life: 3000 });
        })
      }
    
      const rejectResetDelete = () => {
          toast?.current?.show({ severity: 'warn', summary: t('UserAdd.Toast.ResetRejectedSummary'), detail: t('UserAdd.Toast.RequestCancelledDetail'), life: 3000 });
      }
    
    const confirmReset = () => {
        confirmDialog({
            message: t('UserAdd.ConfirmReset.Message'),
            header: t('UserAdd.ConfirmReset.Header'),
            icon: 'pi pi-info-circle',
            rejectClassName: 'p-button-danger',
            acceptLabel: t('UserAdd.ConfirmReset.AcceptNo'),
            rejectLabel: t('UserAdd.ConfirmReset.RejectYes'),
            accept: rejectResetDelete,
            reject: acceptReset
        });
    };

    return (
        <div>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => addNewUser()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => copyUser()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="opacity-25"><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => openFavoriteDialog(t('UserList.Tab.New'),"UserAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("UserAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        
        <div className="relative flex flex-col justify-left overflow-x min-h-[calc(100vh-177px)]">
          <div className=" mb-2 ">
                <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <form onSubmit={userformik.handleSubmit}>
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   {t('UserAdd.Title')}
                </h1>
                {userType=="edit" && <label className="block text-md font-semibold text-gray-800">{t('Common.RecordIdLabel')}: {userformik.values.id}</label>}
                <div className="mt-6 md:grid grid-cols-2 gap-4 mb-2">
                    <div>
                      <label
                            htmlFor="username"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('UserAdd.Label.Username')}
                        </label>
                        <input
                            name='username'
                            type="text"
                            onChange={userformik.handleChange} value={userformik.values.username}
                            className="block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {userformik.errors.username ? <div style={{color:'red'}}>{userformik.errors.username}</div> : null}
                        </div>
                        <div>
                        <label
                            htmlFor="role"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('UserAdd.Label.Role')}
                        </label>
                        <select 
                        name='role'
                        onChange={userformik.handleChange} value={userformik.values.role}
                        className='block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('UserAdd.SelectRole')}</option>
                          {state.roles.map((role) => (
                            <option key={role.id} value={role.name}>{role.name}</option>
                          ))}
                        </select>
                        {userformik.errors.role ? <div style={{color:'red'}}>{userformik.errors.role}</div> : null}
                        </div>   
                        <div>
                        <label
                            htmlFor="employee_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('UserAdd.Label.AssignedToEmployee')}
                        </label>
                        <select 
                        name='employee_id'
                        value={userformik.values.employee_id} onChange={userformik.handleChange}
                        className='block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                           <option value="">{t('UserAdd.OptionDepartments')}</option>
                          {state.employees.filter(employee => (employee.user == null && employee.date_of_departure == null) || employee.user?.id == formUser?.id).map((employee) => (
                            <option key={employee.id} value={employee.id}>{employee.name}</option>
                          ))}
                        </select>
                        {userformik.errors.employee_id ? <div style={{color:'red'}}>{userformik.errors.employee_id}</div> : null}
                        </div>
                        {(userformik.values.employee_id == null || userformik.values.employee_id == "") ? <div>
                        <label className="block text-md font-semibold text-gray-800">{t('UserAdd.Label.Departments')}</label>
                        <div className='grid grid-cols-2'>
                            {state.priority_departments.map((department) => 
                                <div className="flex align-items-center">
                                    <Checkbox inputId={department.id} name="departments" value={department.id} onChange={onDepartmentsChange} checked={priorityDepartments.includes(department.id)} className='p-button-sm p-button-text'/>
                                    <label htmlFor={department.id} className="ml-2">{department.name}</label>
                                </div>
                            )}
                        </div></div>:<div></div>}
                        <div>
                        {userType=="edit" &&
                            <button type="button" className='w-full font-medium mb-2 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600' onClick={() => confirmReset()}>{t('UserAdd.ResetPassword')}</button>
                        }
                        </div>
                </div>  
                <button type="submit" ref={submitRef} className='hidden'></button>  
                </form>       
            </div>
            </div>
            <div>
            </div>
        </div>
            <Dialog header={t('UserAdd.Dialog.InitialPasswordHeader')} visible={visiblePassword} style={{ width: '50vw' }} onHide={() => {setNewPassword("");setVisiblePassword(false);if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});}}>
            <p className="m-0">
                {newPassword}
            </p>
        </Dialog>
        </div>
    );
}